var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTickCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 26,
  viewBox: "0 0 25 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25 13C25 19.9036 19.4036 25.5 12.5 25.5C5.59644 25.5 0 19.9036 0 13C0 6.09644 5.59644 0.5 12.5 0.5C19.4036 0.5 25 6.09644 25 13Z",
  fill: "#FFCA05"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0957 16.4492L10.0996 16.4454L10.0957 16.4492Z",
  fill: "#001246"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.9194 19.1667L5 13.1442L7.38647 10.7473L10.9194 14.3106L17.6141 7.5L20 9.92801L10.9194 19.1667Z",
  fill: "#001246"
})));
export default SvgIconTickCircle;